import { Floor } from '@/entities/map'
import { useMultiScrollState } from '@/shared/lib'

import { FilterChip } from './filter-chip'
import { Filter, useFilter } from '../../model/filter'

const FLOORS = [
  {
    title: '반지하',
    value: Floor.SEMI_BASEMENT,
  },

  {
    title: '1층',
    value: Floor.FIRST_FLOOR,
  },
  {
    title: '2층 ~ 9층',
    value: Floor.FROM_SECOND_TO_NINE,
  },
  {
    title: '10층 이상',
    value: Floor.OVER_TEN,
  },
]

export const Floors = () => {
  const { registerScrollElement } = useMultiScrollState<HTMLDivElement>()

  const {
    filter: { floors },
    updateFilter,
  } = useFilter()

  const handleFloorChange = (value: Floor) => () => {
    updateFilter({ floors: value })
  }

  return (
    <div
      className="p-6 pt-0 pr-4"
      ref={element => {
        if (element) {
          registerScrollElement(Filter.Floors, element)
        }
      }}
    >
      <h3 className="typo-body1 mb-3 font-semibold text-black">층수</h3>
      <ul className="flex flex-wrap gap-2">
        {FLOORS.map(({ title, value }) => (
          <li key={value}>
            <FilterChip
              selected={floors.includes(value)}
              onClick={handleFloorChange(value)}
            >
              {title}
            </FilterChip>
          </li>
        ))}
      </ul>
    </div>
  )
}
